const ExclamationMarkIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      aria-hidden='true'
      className={className}
      width='1512'
      height='4800'
      viewBox='0 0 1512 4800'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        opacity='0.5'
        d='M369.659 3030L923.262 450L1596.56 585L1042.96 3180L369.659 3030ZM594.092 4050C594.092 4305 788.602 4500 1042.96 4500C1297.32 4500 1491.83 4305 1491.83 4050C1491.83 3795 1297.32 3600 1042.96 3600C788.602 3600 594.092 3795 594.092 4050ZM594.092 4050C594.092 4305 788.602 4500 1042.96 4500C1297.32 4500 1491.83 4305 1491.83 4050C1491.83 3795 1297.32 3600 1042.96 3600C788.602 3600 594.092 3795 594.092 4050Z'
        fill='currentColor'
      />
    </svg>
  );
};
export default ExclamationMarkIcon;
